export const ESTADOS = [
	{ sigla: "AC", id: 3, nome:"Acre" },
	{ sigla: "AL", id: 4, nome:"Alagoas" },
	{ sigla: "AM", id: 6, nome:"Amazonas" },
	{ sigla: "AP", id: 5, nome:"Amapá" },
	{ sigla: "BA", id: 7, nome:"Bahia" },
	{ sigla: "CE", id: 8, nome:"Ceará" },
	{ sigla: "DF", id: 9, nome:"Distrito Federal" },
	{ sigla: "ES", id: 10, nome:"Espírito Santo" },
	{ sigla: "GO", id: 11, nome:"Goiás" },
	{ sigla: "MA", id: 2, nome:"Maranhão" },
	{ sigla: "MG", id: 14, nome:"Minas Gerais" },
	{ sigla: "MS", id: 13, nome:"Mato Grosso do Sul" },
	{ sigla: "MT", id: 12, nome:"Mato Grosso" },
	{ sigla: "PA", id: 15, nome:"Pará" },
	{ sigla: "PB", id: 16, nome:"Paraíba" },
	{ sigla: "PE", id: 18, nome:"Pernambuco" },
	{ sigla: "PI", id: 1, nome:"Piauí" },
	{ sigla: "PR", id: 17, nome:"Paraná" },
	{ sigla: "RJ", id: 19, nome:"Rio de Janeiro" },
	{ sigla: "RN", id: 20, nome:"Rio Grande do Norte" },
	{ sigla: "RO", id: 22, nome:"Rondônia" },
	{ sigla: "RR", id: 23, nome:"Roraima" },
	{ sigla: "RS", id: 21, nome:"Rio Grande do Sul" },
	{ sigla: "SC", id: 24, nome:"Santa Catarina" },
	{ sigla: "SE", id: 26, nome:"Sergipe" },
	{ sigla: "SP", id: 25, nome:"São Paulo" },
	{ sigla: "TO", id: 27, nome:"Tocantins" }
]

export const TIPOS_IMOVEIS = [
	{ nome: "Apartamento", id: 1 },
	{ nome: "Casa Comercial", id: 2 },
	{ nome: "Casa em Condomínio", id: 3 },
	{ nome: "Casa Residencial", id: 4 },
	{ nome: "Flat/Apart Hotel", id: 5 },
	{ nome: "Galpão", id: 6 },
	{ nome: "Lote em Condomínio", id: 12 },
	{ nome: "Loja/Sala Comercial", id: 7 },
	{ nome: "Lote/Terreno", id: 8 },
	{ nome: "Ponto Comercial", id: 11 },
	{ nome: "Prédio Comercial", id: 14 },
	{ nome: "Quiosque", id: 13 },
	{ nome: "Quitinete", id: 9 },
	{ nome: "Sítio/Chácara", id: 10 }
];

export const CATEGORIAS_VENDA = [
  { label: "Imóvel Avulso", data: "IMOVEL_AVULSO" },
	{ label: "Lançamento", data: "LANCAMENTO" }
];

export const STATUS_VENDA = [
  { label: "Disponível", data: "DISPONIVEL" },
	{ label: "Indisponível", data: "INDISPONIVEL" },
  { label: "Vendido", data: "VENDIDO" },
  { label: "Reservado", data: "RESERVADO" },
	{ label: "Arquivado", data: "ARQUIVADO" }
];

export const STATUS_CONTRATO = [
	{ label: "" },
  { label: "Pendente", data: "PENDENTE" },
	{ label: "Aprovado", data: "APROVADO" }
];

export const OPERACAO_IMOVEL = [
	{ label: "Aluguel", data: "ALUGUEL" },
	{ label: "Venda", data: "VENDA" }
]

export const POSSE_CHAVE = [
  { label: "Proprietário", data: "PROPRIETARIO" },
  { label: "Imobiliária", data: "IMOBILIARIA" },
  { label: "Outro", data: "OUTRO" }
]

export const AUTORIZACAO_VENDA = [
  { label: "Escrita", data: "ESCRITA" },
  { label: "Verbal", data: "VERBAL" }
]

export const AUTORIZACAO_PLACA = [
  { label: "Colocação de placa permitida pelo proprietário", data: "PERMITIDO" },
  { label: "Proprietário não permitiu colocar placa", data: "PROPRITARIO_NAO_PERMITIU" },
  { label: "Não é possível colocar placa", data: "NAO_PODE_COLOCAR_PLACA" }
]

export const OCORRENCIA_RETIRADA_PLACA = [
  { label: "Placa Retirada", data: "RETIRADA" },
  { label: "Placa Extraviada", data: "EXTRAVIADA" }
]

export const DURACAO_RESERVA = [
  { label: "24h", data: 24 },
  { label: "36h", data: 36 },
  { label: "48h", data: 48 }
]

export const BANCOS = [
	{ label: "Banco do Brasil", data: "BANCO_DO_BRASIL" },
	{ label: "Banco do Nordeste", data: "BANCO_DO_NORDESTE" },
	{ label: "Banco Real", data: "BANCO_REAL" },
	{ label: "Bradesco", data: "BRADESCO" },
	{ label: "Caixa Econômica", data: "CAIXA_ECONOMICA" },
	{ label: "Itaú", data: "ITAU" },
	{ label: "Santander", data: "SANTANDER" },
	{ label: "Sicoob", data: "SICOOB" },
	{ label: "Sudameris", data: "SUDAMERIS" }
]

export const STATUS_CONTA = [
	{ label: "Ativo", data: "ATIVO" },
	{ label: "Inativo", data: "INATIVO" }
]

export const TIPO_CONTA = [
	{label: "Conta Corrente", data: "CONTA_CORRENTE"},
	{label: "Conta Poupança", data: "CONTA_POUPANCA"}
]

export const STATUS_CONTATO = [
	{label: "Em Andamento", data: "EM_ANDAMENTO"}, 
	{label: "Concluído", data: "CONCLUIDO"}
]

export const STATUS_PAGAMENTO = [
	{label: "Pago", data: "PAGO"}, 
	{label: "Em Aberto", data: "EM_ABERTO"}
]

export const ESTADO_CIVIL = [
	{label: "Solteiro", data: "SOLTEIRO"},
	{label: "Casado", data: "CASADO"},
	{label: "Divorciado", data: "DIVORCIADO"},
	{label: "Viúvo", data: "VIUVO"},
	{label: "União Estável", data: "UNIAO_ESTAVEL"}
]

export const CATEGORIA_CLIENTE = [
	{ label: "Proprietários/Locatários", data: "PROPRITARIO_LOCATARIO" },
	{ label: "Proprietários", data: "PROPRIETARIO" },
	{ label: "Beneficiários", data: "BENEFICIARIO" },
	{ label: "Locatários", data: "LOCATARIO" },
	{ label: "Fiadores", data: "FIADOR" },
	{ label: "Pretendentes", data: "PRETENDENTE" }
]